import {
  Group,
  Text,
  UnstyledButton,
  Code,
  useMantineTheme,
  TextInput,
  Button,
} from "@mantine/core";
import { IconSearch } from "@tabler/icons-react";
import { modals, openModal } from "@mantine/modals";
import SpotlightForm from "./SpotlightForm";
import { useEffect, useRef } from "react";
import { createStyles } from "@mantine/emotion";
// import type { SpotlightAction } from '@mantine/spotlight';
import classes from "./SpotlightControl.module.scss";
import { logger } from "utils/logger";
import { AppConstants } from "utils/constants";
import { connect } from "react-redux";

const SpotlightControl = ({ globalSearch }) => {
  // const spotlight = useSpotlight();
  //   const classes = useStyles();
  const theme = useMantineTheme();

  const openGlobalSearch = () => {
    logger.log("her");
    // modals.open({
    //   title: "",
    //   size: "lg",
    //   withCloseButton: false,
    //   className: "spotlight-modal",
    //   children: (
    //     <>
    //       <SpotlightForm />
    //     </>
    //   ),
    // });

    modals.open({
      title: "",
      size: "100%",
      withCloseButton: false,
      className: `spotlightModal ${
        globalSearch?.results && globalSearch?.results.length > 0
          ? "open"
          : Array.isArray(globalSearch?.results) &&
            globalSearch?.results.length === 0
          ? "empty"
          : ""
      }`,
      closeOnEscape: false,
      p: "0",
      children: (
        <>
          <SpotlightForm />
        </>
      ),
    });
  };

  useEffect(() => {
    const handleKeyPress = (event) => {
      // Check if the pressed key is 'K' and if the Command key is also pressed
      if (event.key === "k" && (event.metaKey || event.ctrlKey)) {
        event.preventDefault(); // Prevent the default browser behavior
        openGlobalSearch(); // Call your function here
      }
    };

    // Add event listener
    window.addEventListener("keydown", handleKeyPress);

    // Cleanup function to remove event listener
    return () => {
      window.removeEventListener("keydown", handleKeyPress);
    };
  }, []); //

  // Update modal className when globalSearch changes
  // useEffect(() => {
  //   logger.log('globalSearch', globalSearch);
  //   const modalElement = document.querySelector('.spotlightModal');
  //   if (modalElement) {
  //     const results = globalSearch?.results;
  //     const hasResults = results && results.length > 0;
  //     const isEmpty = Array.isArray(results) && results.length === 0;

  //     if (hasResults) {
  //       modalElement.classList.add('open');
  //       modalElement.classList.remove('empty');
  //     } else if (isEmpty) {
  //       modalElement.classList.remove('open');
  //       modalElement.classList.add('empty');
  //     } else {
  //       // results is undefined/null
  //       modalElement.classList.remove('open');
  //       modalElement.classList.remove('empty');
  //     }
  //   }
  // }, [globalSearch?.results]);

  // Update modal className when globalSearch changes
  // useEffect(() => {
  //   logger.log('globalSearch', globalSearch);

  //   // Use a small delay to ensure modal is rendered
  //   const timeoutId = setTimeout(() => {
  //     const modalElement = document.querySelector('.spotlightModal');
  //     if (modalElement) {
  //       const results = globalSearch?.results;
  //       const hasResults = results && results.length > 0;
  //       const isEmpty = Array.isArray(results) && results.length === 0;

  //       // Remove both classes first
  //       modalElement.classList.remove('open', 'empty');

  //       // Add appropriate class
  //       if (hasResults) {
  //         modalElement.classList.add('open');
  //       } else if (isEmpty) {
  //         modalElement.classList.add('empty');
  //       }
  //     }
  //   }, 200); // Use setTimeout to ensure DOM is ready

  //   return () => clearTimeout(timeoutId);
  // }, [globalSearch?.results]);

  const modalElementRef = useRef(null);

  // Update modal className when globalSearch changes
  useEffect(() => {
    const updateModalClasses = () => {
      const modalElement =
        modalElementRef.current || document.querySelector(".spotlightModal");

      if (!modalElement) {
        // Modal not rendered yet, try again on next frame
        requestAnimationFrame(updateModalClasses);
        return;
      }

      // Cache the element for future updates
      if (!modalElementRef.current) {
        modalElementRef.current = modalElement;
      }

      const results = globalSearch?.results;
      const hasResults = results?.length > 0;
      const isEmpty = Array.isArray(results) && results.length === 0;

      // Batch DOM updates
      modalElement.classList.toggle("open", hasResults);
      modalElement.classList.toggle("empty", isEmpty);
    };

    // Use requestAnimationFrame for better performance (faster than setTimeout)
    const rafId = requestAnimationFrame(updateModalClasses);

    return () => {
      cancelAnimationFrame(rafId);
    };
  }, [globalSearch?.results]);

  return (
    <Group position="center">
      {/* <UnstyledButton onClick={spotlight.openSpotlight}>test</UnstyledButton> */}
      <UnstyledButton
        onClick={openGlobalSearch}
        w={300}
        className={classes.container}
      >
        <Group className={[classes.buttonInner, classes.content]} gap={"xs"}>
          <IconSearch size={AppConstants.ICON_SIZE} color="grey" />
          <Text style={{ flexGrow: 1 }} size="sm">
            Quick Style Lookup
          </Text>
          <Code
            className={classes.code}
            // style={(theme) => ({
            //   // subscribe to color scheme changes
            //   border:
            //     theme.colorScheme === "dark"
            //       ? `1px solid ${theme.colors.dark[3]}`
            //       : `1px solid ${theme.colors.gray[2]}`,
            // })}
          >
            ⌘ + K
          </Code>
          {/* <Text size="xs" color="gray">bob@handsome.inc</Text> */}
        </Group>
      </UnstyledButton>
    </Group>
  );
};

// add redux connect
const mapStateToProps = (state) => ({
  globalSearch: state.appReducer.globalSearch,
});

export default connect(mapStateToProps)(SpotlightControl);
// export default SpotlightControl;
